class JsUtils {
  static isEmpty (val) {
    if (Array.isArray(val)) {
      return val.length === 0
    }

    if (typeof val === 'undefined') {
      return true
    }

    if (val === null) {
      return true
    }

    if (Object.keys(val).length === 0 && val.constructor === Object) {
      return true
    }

    if (val === 0) {
      return false
    }

    if (val === false) {
      return false
    }

    return !val
  }

  static isValidEmailAddress (emailAddress) {
    let pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i)
    return pattern.test(emailAddress)
  };

  static isEqual (value, other) {
    // Get the value type
    let type = Object.prototype.toString.call(value)

    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false

    // If items are not an object or array, return false
    if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false

    // Compare the length of the length of the two items
    let valueLen = type === '[object Array]' ? value.length : Object.keys(value).length
    let otherLen = type === '[object Array]' ? other.length : Object.keys(other).length
    if (valueLen !== otherLen) return false

    // Compare two items
    let compare = function (item1, item2) {
      // Get the object type
      let itemType = Object.prototype.toString.call(item1)

      // If an object or array, compare recursively
      if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
        if (!JsUtils.isEqual(item1, item2)) {
          return false
        }
      } else {
        // Otherwise, do a simple comparison
        // If the two items are not the same type, return false
        if (itemType !== Object.prototype.toString.call(item2)) return false

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (itemType === '[object Function]') {
          if (item1.toString() !== item2.toString()) return false
        } else {
          if (item1 !== item2) return false
        }
      }
    }

    // Compare properties
    if (type === '[object Array]') {
      for (let i = 0; i < valueLen; i++) {
        if (compare(value[i], other[i]) === false) return false
      }
    } else {
      for (let key in value) {
        if (value.hasOwnProperty(key)) {
          if (compare(value[key], other[key]) === false) return false
        }
      }
    }

    // If nothing failed, return true
    return true
  }
}

export default JsUtils



// WEBPACK FOOTER //
// ./src/util/JsUtils.js